import { PracticeVM } from 'practice/view-models/practice-research';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<PracticeVM, keyof PracticeVM>[] = [
  {
    id: 'pratice',
    label: 'Pratica',
  },
  {
    id: 'type',
    label: 'Tipo pratica',
  },
  {
    id: 'priorita',
    label: 'Priorità',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'fiscalCode',
    label: 'CF',
  },
  {
    id: 'dateDecorrenza',
    label: 'Data decorrenza',
  },
  {
    id: 'dateOpen',
    label: 'Data apertura',
  },
  {
    id: 'dateClose',
    label: 'Data chiusura',
  },
  // {
  //   id: 'dateExchangeState',
  //   label: 'Data cambio stato',
  // },
  {
    id: 'lastTypeOperation',
    label: 'Ultima operazione',
  },
  {
    id: 'acquisition',
    label: 'Sistema acquisizione',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'notifications',
    label: 'Notifiche',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
